import {
  HiOutlineChatBubbleLeft,
  HiOutlineHome,
  HiOutlineInformationCircle,
} from "react-icons/hi2";
import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import { useRetractableMenu } from "../context/RetractableMenuContext";

const StyledNavigation = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  width: 100%;
`;

const NavItem = styled.li`
  display: flex;
  padding: 0.6rem;

  color: var(--navigation);
  background: none;
  border-radius: 1.5rem;
  transition: all 0.2s;

  & a {
    display: flex;
    align-items: center;
    gap: 1rem;

    width: 100%;
  }

  &:hover {
    background-color: var(--icon-color-hover);
  }
`;

const StyledLink = styled(NavLink)`
  & svg {
    height: 1.5rem;
    width: 1.5rem;
    color: var(--navigation);
  }
`;

const SpanText = styled.span`
  opacity: 0;
  visibility: hidden;
  margin-left: 0;
  position: absolute;

  ${(props) =>
    props.isExpanded &&
    css`
      opacity: 1;
      visibility: visible;
      margin-left: 2rem;
      transition: opacity 0.3s ease, visibility 0s 0s, margin-left 0.3s ease;
    `}
`;

function Navigation() {
  const { isExpanded, closeMenuAfterClick } = useRetractableMenu();
  
  return (
    <StyledNavigation isExpanded={isExpanded}>
      <NavItem>
        <StyledLink to="/" end onClick={closeMenuAfterClick}>
          <HiOutlineHome />
          <SpanText isExpanded={isExpanded}>Home</SpanText>
        </StyledLink>
      </NavItem>

      <NavItem>
        <StyledLink to="/chat" onClick={closeMenuAfterClick}>
          <HiOutlineChatBubbleLeft />
          <SpanText isExpanded={isExpanded}>Chat</SpanText>
        </StyledLink>
      </NavItem>

      <NavItem>
        <StyledLink to="/about" onClick={closeMenuAfterClick}>
          <HiOutlineInformationCircle />
          <SpanText isExpanded={isExpanded}>Sources</SpanText>
        </StyledLink>
      </NavItem>
    </StyledNavigation>
  );
}

export default Navigation;
